<template>
    <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    max-width="1000px"
    scrollable
    z-index="210"
  >
        <v-card >
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">Whats New?</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row v-if="!loading">
                    <v-col cols="12" v-for="article in data" :key="article.id">
                        <v-card class="mb-4 pa-0" :elevation="0">
                            <v-card-title class="text-h4 text-primary-700 pb-0">{{article.title}}</v-card-title>
                            <v-card-text class="text-h7 py-0">{{article.date}}</v-card-text>
                            <v-card-text class="text-h6 pb-0">{{article.description}}</v-card-text>

                            <v-card-text v-html="formatContent(article.body)">
                            </v-card-text>
                        </v-card>
                        <v-divider v-if="data.indexOf(article) !== data.length - 1"></v-divider>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="10"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="6"></v-skeleton-loader>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>

    export default {
        components: {

        },

        data: () => ({
            dialog: false,
            loading: false,
            data: {},
        }),

        methods: {
            showDialog: function (dealID) {
                this.dialog = true;
            },

            closeDialog: function () {
                this.dialog = false;
            },

            async getWhatsNew() {
                this.loading = true;
                // this.$http.get(this.requestUrl+`/api/_content/query`, {
                //     params:{
                //         _params: {"where":[{"_path":{"$contains":"/news/"}}],"sort":[{"date":-1,"$numeric":true}]}
                //
                //     }
                // })
                // .then(response => {
                //     this.data = response.data;
                //     this.checkActivity();
                //     this.loading = false;
                // })
                // .catch(error => {
                //     console.log(error);
                // });
            },

            formatContent(content){
                // content is in the form content.children[0] = {children: [{type: "text", value: "Hello"}], tag: "p", type: "element"}
                // and we want to return "<p>Hello</p>" and so on for every element in content.children
                // we need to account for nested elements as well by calling formatContent recursively
                // elements may have props like class, style, etc. which we need to account for as well
                let formattedContent = "";

                content.children.forEach(element => {
                    if(element.type === "element"){
                        // if tag is image
                        if (element.tag === "img") {
                            // if the src starts with /, it is a relative path, so we need to add the base url
                            let src = element.props.src;
                            if (src.startsWith("/")) {
                                src = this.requestUrl + src;
                            }
                            formattedContent += `<img src="${src}" alt="${element.props.alt}" style="${element.props.style}; max-width:100%">`;
                        }else if (element.tag === "a") {
                            // if the link starts with /, it is a relative path, so we need to add the base url
                            let href = element.props.href;
                            if (href.startsWith("/")) {
                                href = this.requestUrl + href;
                            }
                            formattedContent += `<a href="${href}" target="_blank" style="${element.props.style}">${this.formatContent(element)}</a>`;
                        } else {
                            formattedContent += `<${element.tag} style="${element.props.style}">${this.formatContent(element)}</${element.tag}>`;
                        }
                    } else if(element.type === "text"){
                        formattedContent += element.value;
                    }
                });

                return formattedContent;
            },

            checkActivity(){
                let last_activity = this.$store.state.user.last_activity;
                let articles = this.data;
                let newArticles = articles.filter(article => {
                    return new Date(article.date) > new Date(last_activity);
                });
                if(newArticles.length > 0){
                    this.data = newArticles;
                    this.dialog = true;
                }
                if(last_activity){
                    this.$store.commit('updateActivity');
                }
            }

        },
        computed: {
            requestUrl() {
                // if APP_ENV is local, use http://localhost:3000, otherwise use https://rp-database.com
                return process.env.VUE_APP_CUSTOMER;
            }
        },

        mounted() {
            this.getWhatsNew();
        }
    }

</script>
<style>
    .deal-td{
        width: 200px;
    }

    ul{
        margin-bottom: 16px;
    }
</style>
